import React from 'react';
import RecordTitle from './RecordTitle';

export interface MobileRecordField {
  label: string;
  value: React.ReactNode;
}

export interface MobileRecordCardProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  status?: React.ReactNode;
  fields?: MobileRecordField[];
  actions?: React.ReactNode;
  expandContent?: React.ReactNode;
  isExpanded?: boolean;
  onClick?: () => void;
  className?: string;
}

const MobileRecordCard: React.FC<MobileRecordCardProps> = ({
  title,
  subtitle,
  status,
  fields = [],
  actions,
  expandContent,
  isExpanded = false,
  onClick,
  className = '',
}) => {
  return (
    <article
      className={`mobile-table-card ${onClick ? 'cursor-pointer' : ''} ${isExpanded ? 'ring-1 ring-primary-200' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <RecordTitle title={title} subtitle={subtitle} />
        </div>
        {status && <div className="shrink-0">{status}</div>}
      </div>

      {fields.length > 0 && (
        <dl className="mt-4 grid grid-cols-1 gap-2">
          {fields.map((field) => (
            <div key={field.label} className="flex items-center justify-between gap-4 border-t border-monday-border-light pt-2 first:border-t-0 first:pt-0">
              <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-monday-text-muted">
                {field.label}
              </dt>
              <dd className="min-w-0 text-right text-sm font-semibold text-monday-text">
                {field.value}
              </dd>
            </div>
          ))}
        </dl>
      )}

      {expandContent}

      {actions && (
        <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-monday-border-light pt-3">
          {actions}
        </div>
      )}
    </article>
  );
};

export default MobileRecordCard;
